import { UI } from "../lib/ui"
export class Modal {
    constructor(modal) {
        if(!window.ui) window.ui = new UI
        this.element = modal ? document.getElementById(modal) : document.getElementById('bootstrapModal')
        this.modal = this.element ? new bootstrap.Modal(this.element) : null
        window.modal = this.modal
        this.body = this.modal ? this.element.querySelector('.modal-body') : null
        this.footer = this.modal ? this.element.querySelector('.modal-footer') : null
        this.title = this.modal ? this.element.querySelector('.modal-title') : null
    }
    /**
     *
     * @returns
     */
    get() {
        return this.modal
    }
    /**
     *
     * @param {*} modal
     * @returns
     */
    instance(modal) {
        //console.log('modal.instance')
        if(!modal) throw new Error('Modal instance must be provided')
            const buttonSave = this.element.querySelector('.btn-primary'),
            buttonSaveHTML = buttonSave?.innerHTML,
            buttonCancel = this.element.querySelector('.btn-secondary'),
            buttonCancelHTML = buttonCancel?.innerHTML,
            footerHTML = this.footer.innerHTML

        if(this.body.hasChildNodes())
            this.body.childNodes[0].remove()

        if(modal.body){
            if(typeof modal.body === 'string')
                this.body.innerHTML = modal.body// === str.isHTML()
            if(ui.isElement(modal.body))
                this.body.append(modal.body)
        }
        if(modal.buttonType === "danger")
            buttonSave.classList.add('btn-danger')
        if(modal.title)
            this.title.innerHTML = modal.title
        if(modal.buttonSave)
            buttonSave.innerHTML = modal.buttonSave
        if(modal.style)
            this.element.setAttribute('style',modal.style)
        if(modal.bodyStyle)
            this.body.setAttribute('style',modal.bodyStyle)
        if(modal.btnCloseStyle)
            this.element.querySelector('.btn-close').setAttribute('style',modal.btnCloseStyle)
        buttonSave.removeAttribute('style')
        if(typeof modal.buttonSave === 'boolean' && !modal.buttonSave)
            buttonSave.style.display = 'none'
        if(modal.buttonCancel)
            buttonCancel.innerHTML = modal.buttonCancel
        if(modal.fullscreen)
            modal.size = 'fullscreen'
        if(modal.size)
            this.element.querySelector('.modal-dialog').classList.add('modal-'+modal.size)
        if(modal.centered)
            this.element.querySelector('.modal-dialog').classList.add('modal-dialog-centered')
        let onSaveEvent
        if(modal.onSave){
            onSaveEvent = (event)=>{
                event.preventDefault()
                modal.onSave(event,modal)
                this.modal.hide()
            }
            buttonSave.addEventListener('click',onSaveEvent)
        }
        let onCancelEvent
        if(modal.onCancel){
            onCancelEvent = (event)=>{
                event.preventDefault()
                modal.onCancel(event,modal)
                this.modal.hide()
            }
            buttonCancel.addEventListener('click',onCancelEvent)
        }
        let onOpenEvent,onOpenEventAdded
        if(modal.onOpen && !onOpenEventAdded){
            onOpenEvent = (event) => {
                    if(typeof modal.onOpen === 'function')
                        modal.onOpen(event)
            }
            this.element.removeEventListener('shown.bs.modal', onOpenEvent)
            this.element.addEventListener('shown.bs.modal', onOpenEvent)
            onOpenEventAdded = true
        }


        this.element.addEventListener('hidden.bs.modal',event =>{
            if(onOpenEvent)
                this.element.removeEventListener('shown.bs.modal', onOpenEvent)
            if(modal.buttonSave)
                buttonSave.innerHTML = buttonSaveHTML
            if(modal.buttonCancel)
                buttonCancel.innerHTML = buttonCancelHTML
            if(modal.style)
                this.element.removeAttribute('style')
            if(modal.bodyStyle)
                this.body.removeAttribute('style')
            if(modal.btnCloseStyle)
                this.element.querySelector('.btn-close').removeAttribute('style')
            if(onSaveEvent)
                buttonSave.removeEventListener('click', onSaveEvent)
            if(onCancelEvent)
                buttonCancel.removeEventListener('click', onCancelEvent)
            if(typeof modal.onClose === 'function')
                modal.onClose(event)
            if(modal.size)
                this.element.querySelector('.modal-dialog').classList.remove('modal-'+modal.size)
            if(modal.centered)
                this.element.querySelector('.modal-dialog').classList.remove('modal-dialog-centered')
            this.footer.innerHTML = footerHTML
        })

        this.modal.show()
        return this.modal
    }

}
